import React, { useState } from "react";
import LoadingSpinner from "./loadingSpinner";
import { useLocation } from "@reach/router";
import { __t } from "@/utils/translate";
import { sendEvent } from "@/utils/api";

type EmailSignUpProps = {
    className?: string;
};

const EmailSignUp: React.FC<EmailSignUpProps> = ({ className = "" }) => {
    const [message, setMessage] = useState<string | undefined>();
    const [error, setError] = useState<string | undefined>();
    const [value, setValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setMessage("");
        setError("");
        if (!value) {
            setError('Please complete all required fields!');
            return;
        };

        localStorage.setItem('billing_email', value);

        const body = {
            action: "footer",
            page: location.pathname,
            email: value,
        };
        const res = await sendEvent('subscribe_offers', { email: value, page: window.location.pathname });

        if (res.success) {
            setMessage(__t("You've successfully signed up for our exclusive offers!"));
        } else {
            setError(__t("Unexpected error occurred! Please try again later."));
        }

        setValue("");
    };

    return (
        <>
            <form onSubmit={handleSubmit} className={`${className} flex flex-col mt-5 md:mt-0`}>
                <input
                    className="w-full border border-footer-text-color bg-transparent px-4 py-3 text-base-16 text-footer-text-color mb-4 text-start"
                    type="email"
                    placeholder={__t("Enter your email")}
                    value={value}
                    onChange={onChange}
                />
                <label className="hidden" htmlFor="email-sign-up">
                    {__t("Sign up for exclusive offers")}
                </label>
                <button
                    type="submit"
                    className="w-full px-4 py-3 bg-button-accent-color text-white hover:bg-dark-blu hover:border hover:border-button-accent-color"
                >
                    {isLoading ? <LoadingSpinner /> : __t("Sign up")}
                </button>
            </form>
            {!!message && <div className="mt-[10px] text-sm text-button-accent-color">{message}</div>}
            {!!error && <div className="mt-[10px] text-sm text-error">{error}</div>}
        </>
    );
};

export default EmailSignUp;
